import { useHistory } from "react-router-dom";
import { t } from "../../translations";
import "../styles/section-chef.css";

import ChefHat from "../../assets/chef-hat.png";

import Cooking from "../../assets/cooking.png";
import DeliveryTruck from "../../assets/delivery-truck.png";
import OnlineOrder from "../../assets/online-order.png";
import Receipt from "../../assets/receipt.png";
import Schedule from "../../assets/schedule.png";

import { useState } from "react";
import { UPDATE } from "../constants/request-type";
import { service_api } from "../constants/url";
import { MakeRequestAsync } from "../functions/axios";
import { decryptSingleData } from "../functions/cryptojs";

import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { POST_USER_DATA } from "../../store/action";
import { createLogger } from "../../utils/logger";

const logger = createLogger("SelectCuisine");
const SelectCuisine = (props) => {
  const { selectedCuisine, setSelectedCuisine, user } = props;
  const history = useHistory();

  const [step, setNextStep] = useState(1);

  const [load, setLoad] = useState(false);

  const lang = useSelector((state) => state.lang);

  const dispatch = useDispatch();

  const post_user_data = (data) => {
    dispatch(post_user(data));
  };

  const saveUpdate = async () => {
    setLoad(true);

    const request_details = {
      type: UPDATE,
      url: service_api,
      route: `user/update-user/${user?._id}`,
      data: {
        speciality_tag: selectedCuisine
      },
      token: user?.refresh_token
    };

    try {
      const response = await MakeRequestAsync(request_details);
      const decryptedData = decryptSingleData(response.data.user);
      post_user_data({
        ...decryptedData
      });
      return history.push("/chef/iam-a-chef/home");
    } catch (err) {
      setLoad(false);
      logger.log("We couldn't fetch data: ", err?.response?.data?.message);
    }
  };

  return (
    <div className="section-chef-menu-right-cuisine-type">
      <div className="section-chef-menu-right-cuisine-type-inside">
        <div
          style={{
            width: "100%",
            height: 10,
            borderRadius: 10,
            backgroundColor: "#d9d9d9"
          }}
        >
          <div
            style={{
              width: `${step * 50}%`,
              height: 10,
              borderRadius: 10,
              backgroundColor: "#ff114d",
              transition: "width 0.3s ease"
            }}
          ></div>
        </div>
        {step === 1 && (
          <div>
            <p
              style={{
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                gap: 15,
                fontWeight: 600,
                marginTop: 30
              }}
            >
              {user?.speciality_tag.length === 0 &&
                t("select_cuisine.welcome", lang)}
              {user?.speciality_tag.length > 0 &&
                t("select_cuisine.modify_specialties", lang)}
              <img src={ChefHat} alt="Chef hat" />
            </p>
            <p
              style={{
                textAlign: "left",
                fontSize: 22
              }}
            >
              {t("select_cuisine.tell_us_more", lang)}
            </p>
            <p
              style={{
                textAlign: "left",
                fontSize: 15
              }}
            >
              {t("select_cuisine.choose_from_specialties", lang)}
            </p>
            <div className="section-chef-menu-right-cuisine-type-inside-box">
              {[
                "breakfast",
                "lunch",
                "dinner",
                "complete_meals",
                "treats",
                "natural_juices"
              ].map((item) => (
                <div
                  onClick={() => {
                    if (selectedCuisine?.includes(item)) {
                      return setSelectedCuisine(
                        [...selectedCuisine]?.filter((e) => e !== item)
                      );
                    }
                    return setSelectedCuisine([...selectedCuisine, item]);
                  }}
                  style={
                    selectedCuisine.includes(item)
                      ? {
                          backgroundColor: "#ffebf0",
                          border: "1px solid #ff114d",
                          color: "#ff114d"
                        }
                      : {}
                  }
                >
                  {t(`select_cuisine.specialties.${item}`, lang)}
                </div>
              ))}
            </div>
          </div>
        )}
        {step === 2 && (
          <div>
            <p
              style={{
                textAlign: "left",
                display: "flex",
                alignItems: "center",
                gap: 15,
                fontWeight: 600,
                marginTop: 30
              }}
            >
              {t("select_cuisine.how_does_it_work", lang)}
            </p>
            {[
              {
                text: t("select_cuisine.choose_availability", lang),
                img: Schedule
              },
              {
                text: t("select_cuisine.receive_orders", lang),
                img: OnlineOrder
              },
              {
                text: t("select_cuisine.cook_cool_pack", lang),
                img: Cooking
              },
              {
                text: t("select_cuisine.delivery_pickup", lang),
                img: DeliveryTruck
              },
              {
                text: t("select_cuisine.receive_payments", lang),
                img: Receipt
              }
            ]?.map((item) => (
              <div
                style={{
                  width: "100%",
                  height: 90,
                  borderRadius: 15,
                  border: "1px solid #eeeeee",
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: 15,
                  alignItems: "center",
                  paddingLeft: 10,
                  fontSize: 16,
                  marginTop: 10
                }}
              >
                <img src={item?.img} alt={item?.text || "Cuisine type"} />
                {item?.text}
              </div>
            ))}
          </div>
        )}
        <div
          className="btn-get-started"
          style={{
            backgroundColor: selectedCuisine.length === 0 ? "gray" : "#ff114d",
            width: step > 1 ? "100%" : "95%"
          }}
          onClick={() => {
            if (load) {
              return;
            }
            if (selectedCuisine.length === 0) {
              return;
            }
            if (step + 1 === 3) {
              return saveUpdate();
            }
            setNextStep(step + 1);
          }}
        >
          {!load && step === 1 && t("select_cuisine.next", lang)}
          {!load && step === 2 && t("select_cuisine.understood", lang)}
          {load && <CircularProgress size={25} />}
        </div>
        {step === 2 && (
          <div
            className="btn-get-started"
            style={{
              backgroundColor: "#fff",
              color: "#000",
              width: step > 0 ? "100%" : "95%"
            }}
            onClick={() => {
              if (load) {
                return;
              }
              setNextStep(step - 1);
            }}
          >
            {t("select_cuisine.back", lang)}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectCuisine;

const post_user = (data) => ({
  type: POST_USER_DATA,
  data: data
});
